var map = {
	"./Recurso 17campus 1.11.png": 8095,
	"./Recurso 18campus 1.11.png": 6426,
	"./Recurso 19campus 1.11.png": 2325,
	"./Recurso 20campus 1.11.png": 8725,
	"./UTN blanco.svg": 2154,
	"./cafop.jpg": 8195,
	"./camarablanco.svg": 8298,
	"./consorcio.jpg": 3431,
	"./oiep.jpg": 3357,
	"./oiepblanco.svg": 8600,
	"./universitam blanco.svg": 7176,
	"./universitam.jpg": 9305,
	"./utn.jpg": 2599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6872;